import React from "react";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import FinancialTotalsContent from "./FinancialTotalsContent";

const FinancialTotals = ({ financialEnabled, onToggleFinancial, ...props }) => {
  return (
    <OverlayTrigger
      placement="bottom"
      rootClose
      trigger={["hover", "focus"]}
      overlay={
        <Popover id="financialPopover" title="Financial Totals">
          <FinancialTotalsContent {...props} />
        </Popover>
      }
    >
      <Button
        active={financialEnabled}
        bsStyle="default"
        onClick={onToggleFinancial}
      >
        Financial
      </Button>
    </OverlayTrigger>
  );
};

export default FinancialTotals;
